import { FC } from 'react';
import Image from 'next/image';
import { isEmpty } from 'radash';
import { IIngredient } from '@modules/recipes/domain/models/recipeDetail.model';
import { Divider } from '@components/divider';
import { BrandType } from '@shared/types/brand.type';
import { IngredientBg, IngredientContainer, IngredientContent, IngredientDetail, IngredientList, SubTitle, Title, TitleWrapper } from './Ingredient.style';
interface Props {
  data: IIngredient;
}
const RecipeIngredient: FC<Props> = ({
  data
}: Props) => {
  const {
    imageUrl,
    list,
    total
  } = data;
  const renderIngredientDetail = () => {
    return list.map((ingredient, index) => {
      return <IngredientDetail key={ingredient.id} $shouldRenderBgColor={!!(index % 2)}>
                    {ingredient.brand === BrandType.Cp ? <a href={ingredient.linkout} target="_blank" className="name-wrapper">
                            <b>{ingredient.name}</b>
                        </a> : <div className="name-wrapper"> {ingredient.name}</div>}

                    <div className="unit">
                        {ingredient.quantity} {ingredient.unit}
                    </div>
                </IngredientDetail>;
    });
  };
  return <IngredientBg>
            <IngredientContainer>
                <TitleWrapper>
                    <Title>ส่วนผสม</Title>
                    <SubTitle>{total} อย่าง</SubTitle>
                </TitleWrapper>
                <Divider />
                <IngredientContent $isHasImage={!isEmpty(imageUrl)}>
                    {imageUrl && <Image src={imageUrl || '/images/default/recipe.jpg'} alt="ingredient image" className="image" onError={({
          currentTarget
        }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = '/images/default/recipe.jpg';
        }} width={350} height={350} />}
                    <IngredientList>{renderIngredientDetail()}</IngredientList>
                </IngredientContent>
            </IngredientContainer>
        </IngredientBg>;
};
export default RecipeIngredient;